<template>
  <div class="popup">
    <div class="header" v-if="hasHeaderSlot">
      <slot name="header"></slot>
    </div>
    <div class="top" :class="{ padded : !removeContentPadding }">
      <modal-actions class="modal-actions" :class="{ padded: removeContentPadding }" :back-action="backAction" :close-action="closeAction" dark-text/>

      <div class="text-wrapper">
        <div v-if="title" class="title" :class="{ padded: removeContentPadding }">{{ title }}</div>
        <div v-else-if="hasTitleSlot" class="title" :class="{ padded: removeContentPadding }">
          <slot name="title"></slot>
        </div>
        <div v-if="hasContentSlot" class="content">
          <slot name="content"></slot>
        </div>
      </div>

      <div class="buttons-wrapper" :class="{ padded: removeContentPadding }">
        <template v-for="(button, key) in buttons">
          <riseup-button :key="`button-${key}`"
                         @click="button.action"
                         :title="button.title"
                         :subtitle="button.subtitle"
                         :variant="button.variant"
                         :color="button.color"
                         :disabled="button.disabled"
                         :icon="button.icon"
                         :loading="button.loading"/>
          <div v-if="orBetweenButtons && key < buttons.length - 1" class="or-separator" :key="key">
            <separator />
            <span class="text">או</span>
            <separator />
          </div>
        </template>
      </div>
    </div>

    <template v-if="hasFooterSlot">
      <separator/>
      <div class="footer-padding">
        <slot name="footer"></slot>
      </div>
    </template>
  </div>
</template>

<script>
import ModalActions from './ModalActions.vue';
import RiseupButton from './RiseupButton/RiseupButton.vue';
import Separator from './Separator.vue';

export default {
  name: 'Popup',
  components: {
    ModalActions,
    RiseupButton,
    Separator,
  },
  props: {
    closeAction: {
      type: Function,
      default: null,
      required: false,
    },
    backAction: {
      type: Function,
      required: false,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    buttons: {
      type: Array,
      required: false,
    },
    removeContentPadding: {
      type: Boolean,
      default: false,
    },
    orBetweenButtons: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots.header;
    },
    hasContentSlot() {
      return !!this.$slots.content;
    },
    hasTitleSlot() {
      return !!this.$slots.title;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../scss/riseup-colors';
  @import '../scss/border-radius';

  .popup {
    .header {
      width: 100%;
      border-radius: $popup-border-radius $popup-border-radius 0 0;
    }
    .top {
      position: relative;
      padding-top: 24px;
      padding-bottom: 24px;
      &.padded {
        padding-left: 24px;
        padding-right: 24px;
      }

      .text-wrapper {
        color: $riseup_black;
        text-align: right;

        .title {
          font-weight: bold;
          font-size: 22px;
          line-height: 24px;
          margin-top: 16px;
          margin-bottom: 20px;
          &.padded {
            padding: 0 24px;
          }
        }

        .content {
          font-size: 16px;
        }
      }

      .buttons-wrapper {
        &.padded {
          padding: 0 24px;
        }
        .riseup-button {
          width: 100%;
          margin-top: 16px;

          &:last-child {
            margin-bottom: 0;
          }
        }

        .or-separator{
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-top: 15px;

          .text{
            padding: 0 10px;
          }
        }
      }
    }

    .footer-padding {
      padding: 24px;
    }
  }
</style>
